import * as Sentry from "@sentry/react";

/**
 * Report a handled Ad Launcher failure without ever turning reporting itself
 * into another user-facing failure.
 */
export function reportAdLauncherError(
  context: string,
  error: unknown,
  extra?: Record<string, unknown>,
): void {
  try {
    if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
      Sentry.captureException(error, {
        tags: { feature: "ad-launcher", context },
        extra,
      });
    }
  } catch {
    // Reporting must never interrupt the action's friendly recovery UI.
  }
  try {
    console.error(`[ad-launcher:${context}]`, error);
  } catch {
    // Some embedded/test consoles can be unavailable; remain nonthrowing.
  }
}